import SbUtils from '../../../../Utils/SbUtils'
import { useState } from 'react';
import { __ } from '@wordpress/i18n';
// perf(SMASH-1836): import the submodule, not the a11y barrel — the barrel
// drags the admin-only Radix stack (accordion/tabs) into the public feed bundle.
import { VisuallyHidden } from '../../../../a11y/VisuallyHidden';

const Caption = ({ feedSettings, post, postIndex, isFeedEditor }) => {
    const [toggleCaption, setToggleCaption] = useState(false);

    const text = post?.video_description;
    const contentLength = feedSettings?.contentLength || 100;
    const shortCaption = text?.substring(0, contentLength);

    // Closes finding v3 M2: the previous read-more button rendered only
    // "..." as its visible content with no accessible name — screen readers
    // announced it as "ellipsis button" (or nothing). Keep the visible "…"
    // for sighted users and add an SR-only label so AT users hear
    // "Read more" / "Show less". Toggles between expand and collapse
    // depending on current state.
    const toggleLabel = toggleCaption
        ? __('Show less', 'sb-customizer')
        : __('Read more', 'sb-customizer');

    return (
        <div className='sb-post-item-caption sb-relative'>
            {toggleCaption ? text : shortCaption}

            {SbUtils.checkNotEmpty(text) && text.length > contentLength &&
                <button
                    type='button'
                    className='sb-post-readmorelink'
                    onClick={() => setToggleCaption(!toggleCaption)}
                    aria-expanded={toggleCaption}
                >
                    <span aria-hidden='true'>{toggleCaption ? ' ' : '…'}</span>
                    <VisuallyHidden>{toggleLabel}</VisuallyHidden>
                </button>
            }

            {isFeedEditor && SbUtils.addHighlighter('post-caption', 'Caption', postIndex)}
        </div>
    )
}

export default Caption;
